import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

export const bonusEnabledPrescriptionTypes: PrescriptionPrescriptionTypeEnum[] =
  [
    PrescriptionPrescriptionTypeEnum.FreePrescription,
    PrescriptionPrescriptionTypeEnum.InsurancePrescription,
    PrescriptionPrescriptionTypeEnum.PrivatePrescription,
  ]
